import { GridColDef } from '@mui/x-data-grid'
import { ColumnLink } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: GridColDef<GridRow>[] = [
  {
    headerName: 'Наименование',
    field: 'name',
    width: 400,
    renderCell: ({ row, value }) => (
      <ColumnLink to={row.id}>{value}</ColumnLink>
    ),
  },
  {
    headerName: 'ИНН',
    field: 'inn',
    flex: 1,
  },
  {
    headerName: 'ОГРН',
    field: 'ogrn',
    flex: 1,
  },
  {
    headerName: 'КПП',
    field: 'kpp',
    flex: 1,
  },
]
